import { dom } from 'react-redux-app/lib/modules/core/utils';

import { getLoginUrl } from '../utils';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_AUTH__REQUEST,
  ACTION_AUTH__SUCCESS,
  ACTION_AUTH__FAIL,

  ACTION_LOGIN__REQUEST,
  ACTION_LOGIN__SUCCESS,
  ACTION_LOGIN__FAIL,

  ACTION_LOGOUT__REQUEST,
  ACTION_LOGOUT__SUCCESS,
  ACTION_LOGOUT__FAIL,

  ACTION_ASK_UNSUSPEND__REQUEST,
  ACTION_ASK_UNSUSPEND__SUCCESS,
  ACTION_ASK_UNSUSPEND__FAIL,

  ACTION_CHANGE_PASSWORD__REQUEST,
  ACTION_CHANGE_PASSWORD__SUCCESS,
  ACTION_CHANGE_PASSWORD__FAIL,

  ACTION_DELETE_ACCOUNT__REQUEST,
  ACTION_DELETE_ACCOUNT__SUCCESS,
  ACTION_DELETE_ACCOUNT__FAIL,

  ACTION_DELETE_NOTIFICATION__REQUEST,
  ACTION_DELETE_NOTIFICATION__SUCCESS,
  ACTION_DELETE_NOTIFICATION__FAIL,
} from '../actionTypes';


const actionAuthSuccess = auth => ({
  type: ACTION_AUTH__SUCCESS,
  payload: auth,
});

const actionAuthFail = error => ({
  type: ACTION_AUTH__FAIL,
  payload: { error },
});

export const actionAuthRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_AUTH__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/auth'
    ).then(
      result => {
        dispatch(actionAuthSuccess(result));
      },
      error => {
        dispatch(actionAuthFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionLoginSuccess = auth => ({
  type: ACTION_LOGIN__SUCCESS,
  payload: auth,
});

const actionLoginFail = error => ({
  type: ACTION_LOGIN__FAIL,
  payload: { error },
});

export const actionLoginRequest = (nick, password) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOGIN__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/login',
      {
        data: {
          nick,
          password,
          realmType: 'ONE_TIME_PASSWORD',
        },
      }
    ).then(
      result => {
        dispatch(actionLoginSuccess(result));
        return dispatch(actionAuthRequest());
      },
      error => {
        dispatch(actionLoginFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionLogoutSuccess = () => ({
  type: ACTION_LOGOUT__SUCCESS,
});

const actionLogoutFail = () => ({
  type: ACTION_LOGOUT__FAIL,
});

export const actionLogoutRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOGOUT__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/logout'
    ).then(
      () => {
        dispatch(actionLogoutSuccess());

        dom.redirect(getLoginUrl(getState()));
      },
      () => {
        dispatch(actionLogoutFail());
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionAskUnsuspendSuccess = () => ({
  type: ACTION_ASK_UNSUSPEND__SUCCESS,
});

const actionAskUnsuspendFail = error => ({
  type: ACTION_ASK_UNSUSPEND__FAIL,
  payload: { error },
});

export const actionAskUnsuspendRequest = (message, email) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_ASK_UNSUSPEND__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/webmaster/send_unsuspend_request',
      { data: { message, email } }
    ).then(
      () => {
        dispatch(actionAskUnsuspendSuccess());
      },
      error => {
        dispatch(actionAskUnsuspendFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionChangePasswordSuccess = auth => ({
  type: ACTION_CHANGE_PASSWORD__SUCCESS,
  payload: auth,
});

const actionChangePasswordFail = error => ({
  type: ACTION_CHANGE_PASSWORD__FAIL,
  payload: { error },
});

export const actionChangePasswordRequest = (oldPassword, newPassword) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_CHANGE_PASSWORD__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/webmaster/change_password',
      { data: { oldPassword, newPassword } }
    ).then(
      result => {
        dispatch(actionChangePasswordSuccess(result));
      },
      error => {
        dispatch(actionChangePasswordFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionDeleteAccountSuccess = auth => ({
  type: ACTION_DELETE_ACCOUNT__SUCCESS,
  payload: auth,
});

const actionDeleteAccountFail = error => ({
  type: ACTION_DELETE_ACCOUNT__FAIL,
  payload: { error },
});

export const actionDeleteAccountRequest = password => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_DELETE_ACCOUNT__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/webmaster/delete_account',
      { data: { password } }
    ).then(
      result => {
        dispatch(actionDeleteAccountSuccess(result));
      },
      error => {
        dispatch(actionDeleteAccountFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionDeleteNotificationSuccess = () => ({
  type: ACTION_DELETE_NOTIFICATION__SUCCESS,
});

const actionDeleteNotificationFail = error => ({
  type: ACTION_DELETE_NOTIFICATION__FAIL,
  payload: { error },
});

export const actionDeleteNotificationRequest = notificationId => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_DELETE_NOTIFICATION__REQUEST,
    });

    return apiClientHelper.del(
      `/rest/webmaster/auth/notification/${notificationId}`
    ).then(
      () => {
        dispatch(actionDeleteNotificationSuccess());
      },
      error => {
        dispatch(actionDeleteNotificationFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
